
import { APIData } from '../constants';
import useRest from './base/useRest';

// ACCOUNTS OR PRODUCTS

const preffix = "documents";

export const useDocuments = (options?: APIData) => {
    return useRest(`${preffix}/`, {...options});
};

export const useDocumentEstimate = (options?: APIData) => {
    return useRest(`${preffix}/estimate`, {...options});
};